// frontend/src/lib/p2p/socket.ts
import { io, Socket } from 'socket.io-client';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://w2usdt.com/api/v1';

/**
 * The WebSocket lives at the *origin* of the API (not under /api/v1).
 * Strip the /api/v1 suffix to derive the socket origin.
 */
function socketOrigin(): string {
  return API_BASE_URL.replace(/\/api\/v1\/?$/, '');
}

let socket: Socket | null = null;

export function getOrderbookSocket(): Socket {
  if (!socket) {
    socket = io(`${socketOrigin()}/orderbook`, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    });
  }
  return socket;
}

export function disconnectOrderbookSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

// Event names — keep in sync with backend OrderbookGateway.
export const WS_EVENTS = {
  SNAPSHOT: 'orderbook:snapshot',
  ORDER_ADDED: 'orderbook:order_added',
  ORDER_UPDATED: 'orderbook:order_updated',
  ORDER_REMOVED: 'orderbook:order_removed',
  TRADE_NEW: 'trades:new',
} as const;
